import React, { useRef } from 'react'

import { Button, Input, Span } from 'components'
import {
  DraggableDialog,
  resetModalState
} from 'components/DraggableDialog/DraggableDialog'
import Draggable from 'react-draggable'
import { COLORS, SPACING } from 'utils'

import {
  DialogActionsStyled,
  DialogContentStyled,
  DialogTitleStyled
} from './ModalObservacao.styles'

interface IModal {
  toggleModal: () => void
  txObservacao?: string
  showModal: boolean
}

export const ModalObservacao = ({
  showModal,
  toggleModal,
  txObservacao,
}: IModal) => {
  const draggableReference = useRef<Draggable>(null)

  return (
    <DraggableDialog
      showModal={showModal}
      reference={draggableReference}
      onClose={toggleModal}
      width={'md'}
    >
      <DialogTitleStyled>Observação do Retorno da Analise</DialogTitleStyled>
      <>
        <DialogContentStyled>
          <Span text={txObservacao} fontSize="0.938rem" color={COLORS.black} />
        </DialogContentStyled>
      </>
      <DialogActionsStyled>
        <Button
          text="Fechar"
          onClick={() => {
            toggleModal()
            resetModalState(draggableReference)
          }}
        />
      </DialogActionsStyled>
    </DraggableDialog>
  )
}
